var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("{{ vm.available }}/{{ vm.maxCharsNumber }}");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/miniComponents/charsCountDownComponent.jade
 ** module id = 592
 ** module chunks = 0
 **/